import {useLocation} from '@github-ui/react-router'
import {useMemo} from 'react'

import {readSavedViewUrlOverrides, type SavedViewUrlParams} from '../utils/saved-view-url-params'
import {useSavedViewUrlActions} from './saved-view-options/use-saved-view-url-actions'

const REPOSITORY_SAVED_VIEW_BASELINE = {layout: 'list', groupBy: null} as const

interface RepositorySavedViewOptions extends SavedViewUrlParams {
  setLayout: ReturnType<typeof useSavedViewUrlActions>['setLayout']
  setGroupBy: ReturnType<typeof useSavedViewUrlActions>['setGroupBy']
  clearOverrides: ReturnType<typeof useSavedViewUrlActions>['clearOverrides']
}

/**
 * Repository saved views still resolve their current configuration from URL overrides.
 * Remove this adapter once their payload supplies baseline and applied configuration.
 */
export function useRepositorySavedViewOptions(): RepositorySavedViewOptions {
  const {search} = useLocation()
  const overrides = useMemo(() => readSavedViewUrlOverrides(new URLSearchParams(search)), [search])
  const current: SavedViewUrlParams = {
    layout: overrides.layout ?? REPOSITORY_SAVED_VIEW_BASELINE.layout,
    groupBy: overrides.groupBy ?? REPOSITORY_SAVED_VIEW_BASELINE.groupBy,
  }
  const actions = useSavedViewUrlActions({baseline: REPOSITORY_SAVED_VIEW_BASELINE, current})

  return {...current, ...actions}
}
